import { render } from "./icon-check.vue?vue&type=template&id=154b415f"
const script = {}

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__